import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

const COLOR_MAP: Record<string, string> = {
  cherry: 'bg-cherry-500 text-white',
  success: 'bg-success text-white',
  warning: 'bg-warning text-warning-fg',
  ton: 'bg-ton-500 text-white',
  purple: 'bg-purple-500 text-white',
};

function timeRemaining(endsAt: string): string {
  const diff = new Date(endsAt).getTime() - Date.now();
  if (diff <= 0) return 'Ended';
  const hours = Math.floor(diff / 3_600_000);
  if (hours >= 24) return `${Math.floor(hours / 24)}d left`;
  if (hours >= 1) return `${hours}h left`;
  return `${Math.floor(diff / 60_000)}m left`;
}

export function EventBanner() {
  const { data } = useQuery({
    queryKey: ['active-events'],
    queryFn: () => api.getActiveEvents(),
    staleTime: 60_000,
  });

  if (!data || data.length === 0) return null;

  return (
    <div className="space-y-2 mb-4">
      {data.map((event) => {
        const colorCls = COLOR_MAP[event.bannerColor] || COLOR_MAP.cherry;
        return (
          <div key={event.id} className={`px-4 py-3 rounded-xl ${colorCls} flex items-center justify-between gap-3`}>
            <div className="min-w-0">
              <p className="font-bold text-sm">{event.bannerText}</p>
              {event.feeNote && (
                <p className="text-xs opacity-90 mt-0.5">{event.feeNote}</p>
              )}
            </div>
            <span className="text-xs font-medium opacity-80 flex-shrink-0">
              {timeRemaining(event.endsAt)}
            </span>
          </div>
        );
      })}
    </div>
  );
}
